import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskLines, SectionLabel } from "./Motion";
import { useT } from "@/i18n";

const STEPS = [
  ["01", "Progetto BIM", "Modelliamo ogni nodo in 3D e verifichiamo carichi, sisma e fuoco prima di tagliare un solo pezzo."],
  ["02", "Selezione del legno", "Abete e larice da foreste gestite, essiccati a umidità controllata e classificati per resistenza."],
  ["03", "Lavorazione CNC", "Incollaggio delle lamelle e sagomatura su centri a 5 assi con tolleranze millimetriche."],
  ["04", "Posa in opera", "Le nostre squadre montano in cantiere in tempi rapidi, a secco e in sicurezza."],
];

const Step = ([n, title, d], i, tr) => (
  <motion.li
    key={n}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, amount: 0.3 }}
    className="relative py-10"
    data-testid={`process-step-${n}`}
  >
    <motion.span variants={{ hidden: { scaleX: 0 }, show: { scaleX: 1, transition: { duration: 1.2, ease: [0.76, 0, 0.24, 1] } } }} className="absolute inset-x-0 top-0 h-px origin-left bg-[#121110]/25" />
    <motion.div variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 0.9, delay: 0.2 } } }} className="grid grid-cols-[auto_1fr] gap-6 sm:gap-10">
      <span className="font-display text-5xl font-extrabold text-[#C26D38] sm:text-7xl" style={{ fontStretch: "75%" }}>{n}</span>
      <div>
        <h3 className="font-display text-2xl font-semibold tracking-tight sm:text-3xl">{tr(`proc.${n}.t`, title)}</h3>
        <p className="mt-3 max-w-md text-base leading-relaxed text-[#6E685E]">{tr(`proc.${n}.d`, d)}</p>
      </div>
    </motion.div>
  </motion.li>
);

export const Process = () => {
  const t = useT();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const clip = useTransform(scrollYProgress, [0.1, 0.45], ["inset(18% 18% 18% 18%)", "inset(0% 0% 0% 0%)"]);

  return (
    <section id="metodo" ref={ref} className="bg-[#F7F5F0] px-5 py-28 text-[#121110] sm:px-8 lg:py-40" data-testid="process-section">
      <div className="mx-auto grid max-w-[1500px] gap-16 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <SectionLabel index="07">{t("proc.label", "Metodo")}</SectionLabel>
            <MaskLines
              className="mt-10 font-display text-4xl font-bold leading-[1.02] tracking-tight sm:text-5xl"
              lines={[t("proc.h1", "Precisione"), <span key="i">{t("proc.h2a", "di")} <em className="font-serif font-normal text-[#C26D38]">{t("proc.h2em", "filiera.")}</em></span>]}
            />
            <motion.div style={{ clipPath: clip }} className="mt-10 h-[340px] overflow-hidden sm:h-[420px]">
              <img src="/img/model.jpg" alt={t("proc.alt", "Modello in scala di casa in legno")} className="h-full w-full object-cover" />
            </motion.div>
          </div>
        </div>
        <ol className="lg:col-span-6 lg:col-start-7">{STEPS.map((s, i) => Step(s, i, t))}</ol>
      </div>
    </section>
  );
};
